import { render, staticRenderFns } from "./BgBlobs.vue?vue&type=template&id=3bd20148&scoped=true&"
import script from "./BgBlobs.vue?vue&type=script&lang=js&"
export * from "./BgBlobs.vue?vue&type=script&lang=js&"
import style0 from "./BgBlobs.vue?vue&type=style&index=0&id=3bd20148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd20148",
  null
  
)

export default component.exports